const AIProcess = ({ stepId, activeTab, description, imageSrc }) => {
  return (
    <div
      id={stepId}
      className={`techstack_content ${activeTab === stepId ? "active" : ""}`}
    >
      <div className="tools-accordion-body">
        <div className="process-right-content">
          <div>
            <img
              src={imageSrc}
              alt="AI development company"
              className="ai_pr_img"
            />
            <h6>{description.title}</h6>
            <p>{description.text}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AIProcess;
